<div class="cover-card" *ngIf="cardData" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()"
     [ngClass]="['theme-' + cardData.theme, 'image-' + cardData.imagePosition, imageLoaded ? 'image-loaded': '', 'animation-' + cardData.text]">
  <div class="cover-card__label" *ngIf="label.length > 0">{{label}}</div>
  <h2 class="cover-card__title" [innerHTML]="cardData.title"></h2>
  <div class="cover-card__shadow"></div>
<!--  <div class="cover-card__image" *ngIf="cardData.image"><brt-image [image]="cardData.image"></brt-image></div>-->
  <div class="cover-card__background-image" *ngIf="cardData.image"><brt-image [image]="cardData.image" (loaded)="onBackgroundImageLoaded()"></brt-image></div>
  <div class="cover-card__animation" *ngIf="cardData.lottieAnimation">
    <brt-lottie
      [lottieOptions]="{autoplay: false, loop: false, path: '/assets/lottie-animations/story_cover/' + cardData.lottieAnimation + '.json'}" (instanceCreated)="onAnimationCreated($event)"></brt-lottie>
  </div>
</div>
